import { z } from "zod";
import { UserQualificationAssignmentFieldsSchema } from "./UserQualification";

export const UserFieldsSchema = z.object({
  id: z.number(),
  username: z.string(),
  email: z.string(),
  firstName: z.string(),
  lastName: z.string(),
  avatar: z.string(),
  phoneNumber: z.string(),
  mobileNumber: z.string(),
  defaultCallendarColor: z.string(),
  isDeleted: z.boolean(),
  verified: z.string().nullable(),
});

export const PartialUserFieldsSchema = UserFieldsSchema.deepPartial();

export const UserExtraFieldsSchema = z.object({
  fullName: z.string(),
  attributes: z.array(z.any()),
  allSuperiors: z.array(z.any()),
  allSubordinates: z.array(z.any()),
  qualifications: z.array(UserQualificationAssignmentFieldsSchema).optional(),
});

export const PartialUserExtraFieldsSchema = UserExtraFieldsSchema.deepPartial();

export const UserSchema = z.intersection(
  UserFieldsSchema,
  UserExtraFieldsSchema
);

export type UserFields = z.infer<typeof UserFieldsSchema>;
export type PartialUserFields = z.infer<typeof PartialUserFieldsSchema>;
export type UserExtraFields = z.infer<typeof UserExtraFieldsSchema>;
export type PartialUserExtraFields = z.infer<
  typeof PartialUserExtraFieldsSchema
>;

export type User = z.infer<typeof UserSchema>;
export type UserPartial = z.infer<typeof PartialUserFieldsSchema>;
